import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router/index.js'
import vuetify from './plugins/vuetify.js'
import '@mdi/font/css/materialdesignicons.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import 'material-symbols/index.css'
import '@fortawesome/fontawesome-free/css/all.min.css'

import FloatingVue from 'floating-vue'
import 'floating-vue/dist/style.css'
import './styles/variables.css'
import './styles/global.css'
import './styles/fonts.css'

// 1. Plus Jakarta Sans (Jakata)
import '@fontsource/plus-jakarta-sans/400.css'
import '@fontsource/plus-jakarta-sans/600.css'
import '@fontsource/plus-jakarta-sans/700.css'

// 2. Google Sans
import '@fontsource/google-sans/400.css'
import '@fontsource/google-sans/500.css'
import '@fontsource/google-sans/700.css'

// 3. Sarabun
import '@fontsource/sarabun/400.css'
import '@fontsource/sarabun/700.css'

// 4. Anuphan
import '@fontsource/anuphan/400.css'
import '@fontsource/anuphan/700.css'

// 5. Kanit & IBM Plex Sans
import '@fontsource/kanit/400.css'
import '@fontsource/kanit/700.css'
import '@fontsource/ibm-plex-sans/400.css'
import '@fontsource/ibm-plex-sans/700.css'
import '@fontsource/ibm-plex-sans-thai/400.css'
import '@fontsource/ibm-plex-sans-thai/700.css'

// 6. Code Fonts: JetBrains Mono & Fira Code
import '@fontsource/jetbrains-mono/400.css'
import '@fontsource/jetbrains-mono/700.css'
import '@fontsource/fira-code/400.css'
import '@fontsource/fira-code/500.css'
import '@fontsource/fira-code/700.css'


// Auto-recover from stale chunks on newly deployed builds
window.addEventListener('vite:preloadError', (event) => {
    event.preventDefault()
    window.location.reload()
})

router.onError((error) => {
    const isChunkError = /Failed to fetch dynamically imported module|MIME type|cross-world/i.test(error?.message || '')
    if (isChunkError && !sessionStorage.getItem('chunk_reload_lock')) {
        sessionStorage.setItem('chunk_reload_lock', 'true')
        window.location.reload()
    }
})

const app = createApp(App)
app.use(createPinia())
app.use(router)
app.use(vuetify)

const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
const isDebugMode = import.meta.env.DEV || (typeof window !== 'undefined' && /[?&](debug|eruda)=1/.test(window.location.search))

if (isMobile && isDebugMode) {
    import('eruda').then((eruda) => {
        try {
            const erudaInstance = eruda.default || eruda
            if (erudaInstance && typeof erudaInstance.init === 'function') {
                erudaInstance.init({
                    useShadowDom: false,
                })
            }
        } catch (err) {
            console.warn('[Eruda] Failed to initialize:', err)
        }
    }).catch((err) => {
        console.warn('[Eruda] Failed to load module:', err)
    })
}

app.use(FloatingVue, {
    themes: {
        'format-dropdown': {
            $extend: 'dropdown',
            triggers: ['hover'],
            autoHide: true,
            delay: { show: 150, hide: 120 }
        }
    }
})
app.mount('#app')

